import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MIN_HEIGHT, MAX_HEIGHT } from './constants';
import DropdownContext from './DropdownContext';
const DISPLAY_NAME = 'DropdownProvider';

/**
 * @ignore - Do not document.
 */
const DropdownProvider = _ref => {
  let {
    minHeight,
    maxHeight,
    children
  } = _ref;
  const value = useMemo(() => ({
    minHeight,
    maxHeight
  }), [minHeight, maxHeight]);
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: value
  }, children);
};
DropdownProvider.displayName = DISPLAY_NAME;
DropdownProvider.defaultProps = {
  minHeight: MIN_HEIGHT,
  maxHeight: MAX_HEIGHT
};
process.env.NODE_ENV !== "production" ? DropdownProvider.propTypes = {
  /**
   * Sets children.
   */
  children: PropTypes.node,
  /**
   * Sets `Dropdown` minimum height.
   */
  minHeight: PropTypes.number,
  /**
   * Sets `Dropdown` maximum height.
   */
  maxHeight: PropTypes.number
} : void 0;
export default DropdownProvider;